import { MouseEvent } from 'react';
import { adobeAnalyticsScriptsSelector } from '../../../redux/features/analytics';
import { tlReadyExecute } from '../../../utils/adobeAnalyticsUtil';
import {
  AnalyticsAppThunk,
  NeededStateForAnalytics,
} from '../../../types/analytics';

/**
 * 絞り込みボタンクリック計測
 * @param event
 * @returns クリック計測
 */
export const measureNarrowDownButtonClick =
  <S extends NeededStateForAnalytics>(
    event: MouseEvent
  ): AnalyticsAppThunk<S> =>
  (dispatch, getState) => {
    const isAdobeScript = adobeAnalyticsScriptsSelector(getState());
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore event.target の型に id が存在しないため
    const buttonId: string = event.target.id;
    const linkName = `click_siborikomi_area_shokushu_${buttonId}`;

    tlReadyExecute(isAdobeScript, dispatch, linkName, {});
  };
